import { render, staticRenderFns } from "./BuildASentence.vue?vue&type=template&id=74f3ea97&scoped=true&"
import script from "./BuildASentence.vue?vue&type=script&lang=js&"
export * from "./BuildASentence.vue?vue&type=script&lang=js&"
import style0 from "./BuildASentence.vue?vue&type=style&index=0&id=74f3ea97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f3ea97",
  null
  
)

export default component.exports